import { IconProps } from '.';

export const CloseIcon = ({ color = 'black', className, ...props }: IconProps & JSX.IntrinsicElements['svg']) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.409 12L7.4545 9.0455L9.0455 7.4545L12 10.409L14.9545 7.4545L16.5455 9.0455L13.591 12L16.5455 14.9545L14.9545 16.5455L12 13.591L9.0455 16.5455L7.4545 14.9545L10.409 12Z'
        fill={color}
      />
    </svg>
  );
};

export const CloseIconWithoutCircle = ({ className, color = 'white' }: IconProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.8392 7.19922L11.9992 11.0392L8.15922 7.19922L7.31922 8.03922L11.1592 11.9992L7.19922 15.9592L8.03922 16.7992L11.9992 12.8392L15.9592 16.7992L16.7992 15.9592L12.8392 11.9992L16.6792 8.03922L15.8392 7.19922Z'
        fill={color}
      />
    </svg>
  );
};
